import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { logout, getOrgId } from "../api";

const ClientHeader = ({ user, onLogout }) => {
    const navigate = useNavigate();
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);

    const handleLogout = async () => {
        await logout();
        onLogout?.();
        navigate("/login", { replace: true });
    };

    const handleResetPassword = () => {
        setIsDropdownOpen(false);
        navigate("/reset-password");
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <header className="cr-header">
            <div className="cr-header-content">
                {/* Logo */}
                <a href="/sessions" onClick={(e) => { e.preventDefault(); navigate("/sessions"); }}
                    className="cr-logo-link">
                    <img src="/assets/logo.svg" alt="Fairpatterns" className="cr-logo-img"
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.style.display = "none";
                            e.target.parentElement.innerHTML = '<span style="font-weight:700;font-size:18px;color:#9180fd">Fairpatterns</span>';
                        }} />
                </a>

                {/* Right: user info + profile dropdown */}
                <div className="cr-user-section">
                    {getOrgId() === process.env.REACT_APP_ADMIN_ORG_ID && (
                        <button
                            className="cr-logout-btn"
                            onClick={() => navigate("/videos")}
                        >
                            Videos
                        </button>
                    )}
                    <button 
                        className="cr-logout-btn" 
                        onClick={() => window.location.href = "https://report.fairpatterns.com/"}
                    >
                        Reports
                    </button>
                    
                    <div className="cr-profile-dropdown" ref={dropdownRef}>
                        <button 
                            className="cr-profile-trigger"
                            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                        >
                            <span>Profile</span>
                            <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 1L6 6L11 1" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                        </button>
                        
                        {isDropdownOpen && (
                            <div className="cr-dropdown-menu">
                                <button className="cr-dropdown-item" onClick={handleResetPassword}>
                                    Reset Password
                                </button>
                                <button className="cr-dropdown-item" onClick={handleLogout}>
                                    Sign out
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </header>
    );
};

export default ClientHeader;
